import React, { useState } from "react";
import { DownArrowIcon, RightArrowIcon } from "../../assets";

const POAccordion = ({ content, product_name, Pagination }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="cl-accordion-item">
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        {isActive ? (
          <img className="cl-down-arrow" src={DownArrowIcon} />
        ) : (
          <img className="cl-right-arrow" src={RightArrowIcon} />
        )}
        <div className="accordion-title-txt">{product_name}</div>
      </div>
      {isActive ? <div className="accordion-content">{content}</div> : null}
      {isActive ? <div>{Pagination}</div> : null}
    </div>
  );
};

export default POAccordion;
